import { solveControllerSelection, validateControllerPlan } from "@automatry/rules";
import { findProductByPartNo, isHardIoCapabilityEligible } from "@automatry/catalog";
import { buildControllerPointLedger } from "./pointLedger.js";
import { NO_RISK, uniqueSourceRefs } from "./strategyContext.js";
export function allocateControllers(projectId, zoneModel, catalog, sourceRequirementIds) {
    const catalogProducts = getCatalogProducts(catalog);
    const selectionPlan = solveControllerSelection({
        fcuZones: zoneModel.fcuZones,
        sameRoomWufhZones: zoneModel.sameRoomWufhZones,
        secondaryZones: zoneModel.secondaryZones,
        standaloneHeatOnlyZones: zoneModel.standaloneHeatOnlyZones
    });
    const constraintTraces = validateControllerPlan(selectionPlan).flatMap((constraint) => constraint.ruleTraceRefs);
    const ruleTraceRefs = [
        ...new Set([
            ...selectionPlan.traces.map((trace) => trace.id),
            ...constraintTraces
        ])
    ];
    const sourceRefs = zoneModel.sourceRefs;
    const controllers = selectionPlan.controllers.map((controller) => {
        const product = findProductByPartNo(catalogProducts, controller.productPartNo);
        const capacity = product?.capabilities.points ?? zeroPoints();
        const sourceRefsWithCatalog = product
            ? uniqueSourceRefs([...sourceRefs, ...product.sourceRefs])
            : sourceRefs;
        const zoneSlots = controller.zoneSlots.map((slot) => ({
            slot: slot.slot,
            logicalZoneId: slot.zoneId,
            role: slot.role,
            notes: slot.combinedLoadZoneIds.length > 0
                ? `${slot.notes} Combined load zones: ${slot.combinedLoadZoneIds.join(", ")}.`
                : slot.notes
        }));
        const pointLedger = buildControllerPointLedger({
            controllerId: controller.id,
            pointDemands: zoneModel.pointDemands,
            zoneSlots,
            capacity,
            sourceRefs: sourceRefsWithCatalog,
            ruleTraceRefs
        });
        const productEligible = product
            ? isHardIoCapabilityEligible(product)
            : false;
        return {
            id: controller.id,
            productPartNo: controller.productPartNo,
            role: controller.role,
            physicalLocation: controller.physicalLocation,
            zoneSlots,
            pointLedger,
            capacity,
            sourceRequirementIds: [...sourceRequirementIds],
            status: productEligible ? "accepted" : "needs_review",
            why: controller.role === "fcu_primary"
                ? "Each FCU zone receives one TP-C-710R-IP controller."
                : "Controller is required by deterministic overflow packing.",
            how: "Allocated with @automatry/rules solveControllerSelection, then checked against product capacity from the supplied catalog release.",
            sourceRefs: sourceRefsWithCatalog,
            ruleTraceRefs,
            risk: productEligible
                ? NO_RISK
                : {
                    level: "blocker",
                    riskRefs: [`risk-${projectId}-${controller.id}-catalog-gap`],
                    notes: "Selected hard-IO product is missing from the catalog products or is not reviewed."
                }
        };
    });
    return {
        controllers,
        catalogProducts,
        ruleTraceRefs
    };
}
export function getCatalogProducts(catalog) {
    const candidate = catalog;
    return Array.isArray(candidate.products) ? candidate.products : [];
}
export function zeroPoints() {
    return {
        ui: 0,
        di: 0,
        ao: 0,
        do: 0,
        relay: 0
    };
}
//# sourceMappingURL=controllerAllocation.js.map